import {
  Breadcrumb,
  Row,
  Input,
  Col,
  Table,
  Button,
} from "antd";
import "../accountList/AccountListPage.css";
import "./ResourceListPage.css";
import moment from "moment";
import { BsSearch } from "react-icons/bs";
import { IoIosArrowDroprightCircle } from "react-icons/io";
import { PlusCircleOutlined } from '@ant-design/icons';
import { RiPencilFill, RiDeleteBinLine } from "react-icons/ri";
import CustomPagination from "../customPagination/CustomPagination";
import { useState, useEffect } from "react";
import { errorNotificationAlert } from "../notificationAlert/noticationAlert";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { SIDEBAR_CONSTANT } from "../../constant/sidebar.constant";
import { RESOURCE_LIST_CONSTANT } from "../../constant/resourcelist.constant";
import resourceListService from "../../service/resourceListService";
import { ROUTER_CONSTANT } from "../../constant/router.constant";

const ResourceListPage = () => {
  const dateToday = new Date();
  const token = useSelector((state) => state.loginData.token);
  const navigate = useNavigate();
  const [dataResource, setDataResource] = useState([]);
  const columns = [
    {
      title: RESOURCE_LIST_CONSTANT.TABLE_LOGO_COLUMN,
      dataIndex: "logo",
      width: "5vw",
      align: "left",
      render: (logo) => (
        <div className="status-position-style">
          <img alt="Logo" className="resource-logo-list-style" src={logo} />
        </div>
      ),
    },
    {
      title: RESOURCE_LIST_CONSTANT.TABLE_RESOURCE_NAME_COLUMN,
      dataIndex: "resource_name",
      width: "8vw",
      align: "left",
      render: (resource_name) => `${resource_name}`,
    },
    {
      title: RESOURCE_LIST_CONSTANT.TABLE_RESOURCE_ID_COLUMN,
      dataIndex: "resource_id",
      width: "8vw",
      align: "left",
      render: (resourceId) => `${resourceId}`,
    },
    {
      title: RESOURCE_LIST_CONSTANT.TABLE_DESCRIPTION_COLUMN,
      dataIndex: "description",
      width: "15vw",
      align: "left",
      render: (description) => (description ? description : ""),
    },
    {
      title: RESOURCE_LIST_CONSTANT.TABLE_ACTION_COLUMN,
      width: "8vw",
      align: "left",
      render: (resourceData) => (
        <Row justify="start">
          <Col span={5}>
            <RiPencilFill
              onClick={() => navigate(`${ROUTER_CONSTANT.HOME}${ROUTER_CONSTANT.RESOURCE_LIST_EDIT}`, { state: resourceData })}
              style={{ fontSize: "20px", cursor: "pointer", color: "rgba(66, 66, 66, 1)" }} />
          </Col>
          <Col span={5}>
            <RiDeleteBinLine
              onClick={() => navigate(`${ROUTER_CONSTANT.HOME}${ROUTER_CONSTANT.RESOURCE_LIST_DELETE}`, { state: resourceData })}
              style={{ fontSize: "20px", cursor: "pointer", color: "rgba(66, 66, 66, 1)" }} />
          </Col>
          <Col span={5}>
            <IoIosArrowDroprightCircle
              onClick={() => navigate(`${ROUTER_CONSTANT.HOME}${ROUTER_CONSTANT.RESOURCE_LIST_DETAIL}`, { state: resourceData })}
              style={{ fontSize: "20px", cursor: "pointer", color: "rgba(66, 66, 66, 1)" }} />
          </Col>
        </Row>
      ),
    },
  ];

  const [paginationData, setPaginationData] = useState(
    {
      current: 1,
      pageSize: 10,
    },
  );

  const [totalCountRow, setTotalCountRow] = useState(0);

  const [filterParams, setFilterParams] = useState(
    {
      SearchValue: "-",
    }
  );

  const onPagination = (currentIndex, currentSize) => {
    setPaginationData(
      {
        ...paginationData,
        current: currentIndex,
        pageSize: currentSize
      }
    );
  }

  const handleSearchValue = (event) => {
    let tempSearchValue = event.target.value || "-";
    setPaginationData({ ...paginationData, current: 1 });
    setFilterParams({ ...filterParams, SearchValue: tempSearchValue });
  }

  useEffect(() => {

    const getResourceList = () => {
      let params = {
        PageSize: paginationData.pageSize,
        PageIndex: paginationData.current,
        SearchValue: filterParams.SearchValue,
      };

      resourceListService.getAllResourceList(token, params)
        .then((response) => {
          if (response.data.nexsoft.payload.status.success) {
            setDataResource(response.data.nexsoft.payload.data.content);
            setTotalCountRow(response.data.nexsoft.payload.data.meta);
          } else {
            setDataResource(response.data.nexsoft.payload.data.content);
            setTotalCountRow(response.data.nexsoft.payload.data.meta);
            errorNotificationAlert(
              RESOURCE_LIST_CONSTANT.NOTIFICATION_ERROR_TITLE,
              RESOURCE_LIST_CONSTANT.NOTIFICATION_ERROR_CONTENT_GET_RESOURCELIST,
              response.data.nexsoft.payload.status.message
            )
          }
        }).catch((error) => {
          errorNotificationAlert(
            RESOURCE_LIST_CONSTANT.NOTIFICATION_ERROR_TITLE,
            RESOURCE_LIST_CONSTANT.NOTIFICATION_ERROR_CONTENT_GET_RESOURCELIST,
            RESOURCE_LIST_CONSTANT.NOTIFICATION_ERROR_CONTENT_DETAIL_GET_RESOURCELIST
          )
        });
    }

    getResourceList();

  }, [filterParams, paginationData, token]);

  return (
    <>
      <Row>
        <Breadcrumb separator=">">
          <Breadcrumb.Item>{SIDEBAR_CONSTANT.MENU_SETTING_LIST}</Breadcrumb.Item>
          <Breadcrumb.Item>{RESOURCE_LIST_CONSTANT.MENU_RESOURCE_LIST}</Breadcrumb.Item>
        </Breadcrumb>
      </Row>

      <Row>
        <div className="accountlist-title">
          {RESOURCE_LIST_CONSTANT.MENU_RESOURCE_LIST}
        </div>
      </Row>

      <Row>
        <span className="accountlist-datetime-span">
          {moment(dateToday).format("DD MMMM YYYY")}
        </span>
      </Row>
      <br />

      <Row justify="space-between">
        <Col span={8}>
          <Input onChange={(e) => handleSearchValue(e)} placeholder={RESOURCE_LIST_CONSTANT.PLACEHOLDER_SEARCH} suffix={<BsSearch />} />
        </Col>
        <Col span={8}>
          <Button style={{ float: "right" }} key="addResource" type="primary"
            onClick={() => navigate(`${ROUTER_CONSTANT.HOME}${ROUTER_CONSTANT.RESOURCE_LIST_ADD}`)}
            icon={<PlusCircleOutlined />}
          >
            {RESOURCE_LIST_CONSTANT.BUTTON_RESOURCE_LIST_ADD}
          </Button>
        </Col>
      </Row>

      <br />

      <Row>
        <div className="table-round-style">
          <Table
            columns={columns}
            dataSource={dataResource}
            pagination={false}
            scroll={{ x: 900 }}
            rowKey="resource_list_id"
            size="small"
          >
          </Table>
          <CustomPagination pagination={paginationData} OnPagination={onPagination} totalCountRow={totalCountRow} />
        </div>
      </Row>
      <br /><br />
    </>
  )
}

export default ResourceListPage;